import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  idToken: null,
  accessToken: null,
  refreshToken: null,
  isLoggedIn: false,
  customAttributes: {},
};

export const AuthSlice = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    setAccessTokens: (state, action) => {
      state.idToken = action?.payload?.id_token;
      state.accessToken = action?.payload?.access_token;
      state.refreshToken = action?.payload?.refresh_token;
      state.isLoggedIn = true;
    },
    setUserAttributes: (state, action) => {
      state.customAttributes = action?.payload;
    },
    clearAuthData: state => {
      state.idToken = null;
      state.accessToken = null;
      state.refreshToken = null;
      state.isLoggedIn = false;
      state.customAttributes = {};
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAccessTokens, setUserAttributes, clearAuthData } = AuthSlice.actions;
export const isLoggedIn = state => state.Auth.isLoggedIn;
export const selectIDToken = state => state.Auth.idToken;
export const selectAccessToken = state => state.Auth.accessToken;
export const selectRefreshToken = state => state.Auth.refreshToken;
export const selectUserAttributes = state => state.Auth.customAttributes;

export default AuthSlice.reducer;
